import React from 'react'

import { Box, BoxProps } from '@mui/material'
import { Icon } from '@iconify/react'

interface TicketTypeIconProps {
  value: string | null | undefined
  size?: number
}

/**
 * チケットタイプのアイコン表示コンポーネント
 * IconifyアイコンとURL画像の両方に対応
 */
export const TicketTypeIcon = React.forwardRef<
  HTMLDivElement,
  TicketTypeIconProps & Omit<BoxProps, 'children'>
>(({ value, size = 20, ...otherProps }, ref) => {
  if (!value) {
    return null
  }

  // Iconifyのアイコン名かどうかを判定（例: mdi:account）
  const isIconifyIcon = !value.startsWith('http')

  if (isIconifyIcon) {
    return (
      <Box
        ref={ref}
        {...otherProps}
        sx={{
          width: size,
          height: size,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          ...otherProps.sx,
        }}
      >
        <Icon icon={value} width={size} height={size} />
      </Box>
    )
  }

  return (
    <Box
      ref={ref}
      {...otherProps}
      sx={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        maxWidth: size,
        maxHeight: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        '& img': {
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        },
        ...otherProps.sx,
      }}
    >
      <img src={value} alt="" />
    </Box>
  )
})

TicketTypeIcon.displayName = 'TicketTypeIcon'
